module.exports = __webpack_public_path__ + "static/media/FestivalVision2.01d12197.JPG";